import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAppConfig } from './core/model/app-config';

@Injectable()
export class AppConfig {
  static settings: IAppConfig;

  constructor(public http: HttpClient) {}

  load(): any {
    const jsonFile = 'config/config.json';

    return new Promise<void>((resolve) => {
      this.http.get(jsonFile).subscribe((response: any) => {
        AppConfig.settings = response;
        resolve();
      });
    });
  }
}
